export function walkUpdateNodeTextContent(node: Node, text: string | ""): string | null | undefined {
    if (node.nodeType === Node.TEXT_NODE || node.childNodes.length === 0) return (node.textContent = text);
    for (const childNode of node.childNodes) {
        if (childNode.nodeType === Node.TEXT_NODE) return (childNode.textContent = text);
        walkUpdateNodeTextContent(childNode, text);
    }
}

export function parseStringToDom(string?: string): Document {
    return new DOMParser().parseFromString(string || "", "text/html");
}

export function executeScripts(container: Element, executed: Set<string>): void {
    const scripts = Array.from(container.querySelectorAll("script"));
    if (container.tagName === "SCRIPT") scripts.unshift(container as HTMLScriptElement);
    for (const node of scripts) {
        const key =
            node.innerHTML +
            Array.from(node.attributes)
                .map(a => `${a.name}=${a.value}`)
                .join(",");
        if (executed.has(key)) continue;
        executed.add(key);
        const clone = document.createElement("script");
        clone.text = node.innerHTML;
        for (const attr of Array.from(node.attributes)) {
            clone.setAttribute(attr.name, attr.value);
        }
        node.parentNode!.replaceChild(clone, node);
    }
}
